import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { BackgroundBeams } from '@/components/ui/background-beams';
import type { AboutSectionData } from '@/sanity/types';

interface AboutCTASectionProps {
  data?: AboutSectionData | undefined;
}

/**
 * R2 - CTA section for About Us page
 * R4 - Accepts optional Sanity data, falls back to hardcoded defaults
 */
export function AboutCTASection({ data }: AboutCTASectionProps) {
  const badge = data?.ctaBadge ?? '¿Necesitas una solución modular?';
  const headingLine1 = data?.ctaHeadingLine1 ?? 'Estamos aquí para';
  const headingLine2 = data?.ctaHeadingLine2 ?? 'ayudarte';
  const description = data?.ctaDescription ?? 'Si necesitas una solución modular fiable y adaptada a tus necesidades, nuestro equipo está listo para asesorarte.';
  return (
    <section className="relative h-[28rem] sm:h-[32rem] w-full bg-slate-50 flex items-center justify-center overflow-hidden">
      <BackgroundBeams />

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <span className="inline-block px-4 py-2 bg-inboca-orange/10 rounded-full text-inboca-orange font-semibold text-sm mb-8">
          {badge}
        </span>

        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight">
          {headingLine1}
          <span className="block text-inboca-teal">{headingLine2}</span>
        </h2>

        <p className="text-lg sm:text-xl text-slate-600 max-w-2xl mx-auto mb-10 leading-relaxed">
          {description}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link
            to="/contacto"
            className="inline-flex items-center justify-center gap-2 bg-inboca-teal hover:bg-inboca-teal/90 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all duration-300 shadow-lg shadow-inboca-teal/20 hover:shadow-xl hover:shadow-inboca-teal/30"
          >
            Contactar Ahora
            <ArrowRight className="h-5 w-5" />
          </Link>
          <Link
            to="/productos"
            className="inline-flex items-center justify-center gap-2 bg-white hover:bg-slate-50 text-slate-700 border-2 border-slate-200 hover:border-inboca-orange px-8 py-4 rounded-lg font-bold text-lg transition-all duration-300 shadow-sm hover:shadow-md"
          >
            Ver Productos
          </Link>
        </div>
      </div>
    </section>
  );
}
